'SalesInvoicePdf'.output({rowsPerPage: 9})
'INVOICE'.title()
'orders'.datatype()

'Header'.section({pageHeading: true})
'order_id'.field({caption: "Invoice Number"})
"order_date".field()
'dueDate'.field()
'billingNameAndCompany'.field({caption: "Bill To"})
'billingAddress'.field({caption: ""})
'billingEmailAndPhone'.field({caption: ""})
'ourBusinessName'.field({caption: "From"})
'ourFromAddress'.field({caption: ""})
'ourContactDetails'.field({caption: ""})
'ourTaxId'.field({caption: "Tax ID"})

'Lines'.manifest()
'order_items'.datatype()
'productUniqueName'.field({caption: "Product", width: 82})
'productSku'.field({caption: "SKU", width: 15})
'_qty'.field({width: 18, caption: "Qty"})
'unitPriceExTax'.field({caption: "Price", width: 18})
'_line_total'.field({caption: "Amount", width: 20})

'Footer'.section({outputFooter: true, width: 130, rightAlign: true})
'orders'.datatype()
'_order_shipping'.field({caption: "Shipping", width: 65})
'fees_total'.field({caption: "Fees", width: 65})
'totalTax'.field({width: 65, caption: "Tax"})
'orderTotalWithCurrency'.field({caption: "Invoice Total", rightAlign: true, width: 65})
'paidAmount'.field({caption: "Paid Amount", rightAlign: true, width: 65})
'unpaidExcludingThis'.field({caption: "Other Invoices Owing", rightAlign: true, width: 65})
'totalDueWithCurrency'.field({caption: "Total to Pay", rightAlign: true, width: 65, fontSize: 12})
'terms'.field({width: 65, rightAlign: true})
'paymentInstructions'.field({width: 65, rightAlign: true})
